interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeader({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeaderProps) {
  const centered = align === "center";
  return (
    <div
      className={`max-w-2xl ${centered ? "mx-auto text-center" : ""}`}
    >
      <div className={`flex items-center gap-2 ${centered ? "justify-center" : ""}`}>
        <span className="h-px w-6 bg-accent-500/70" aria-hidden="true" />
        <span className="text-xs font-medium tracking-[0.25em] text-accent-700 uppercase">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-3 text-2xl md:text-4xl font-semibold text-foreground-950 leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
          {description}
        </p>
      )}
    </div>
  );
}